
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Industries from "../pages/industries/page";
import Contact from "../pages/contact/page";
import Vendors from "../pages/vendors/page";
import Login from "../pages/login/page";
import VendorRegistration from "../pages/vendor-registration/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/industries",
    element: <Industries />,
  },
  {
    path: "/vendors",
    element: <Vendors />,
  },
  {
    path: "/vendor-registration",
    element: <VendorRegistration />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
